import { useQuery } from "@tanstack/react-query";
import api from "@/services/api";
import type { BannersResponse } from "@/types/Banner";

interface UseBannersParams {
  type?: "DESKTOP" | "MOBILE";
}

export const useActiveBanners = (params?: UseBannersParams) => {
  return useQuery({
    queryKey: ["banners", "active", params?.type],
    queryFn: async () => {
      const { data } = await api.get<BannersResponse>("/banners/active", {
        params: params?.type ? { type: params.type } : undefined,
      });
      return data;
    },
    staleTime: 5 * 60 * 1000, // Cache por 5 minutos
  });
};
